module.exports = {"320771001":"中云街道","320771002":"猴嘴街道","320771003":"朝阳街道","320771450":"青口盐场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320771.json
// module id = 991
// module chunks = 0